import { FC } from 'react';
import cn from 'classnames';

import { formatNumberToK } from 'src/shared/lib/math';

import styles from './PsychicCardReadings.module.scss';

import type { IPsychicCardReadings } from '../config/declarations';

export const PsychicCardReadings: FC<IPsychicCardReadings> = ({
  psychic,
  className,
  psychicFrame,
}) => (
  <span className={cn(styles.readings, className)}>
    {`${formatNumberToK(psychic.totalReadings || 0)} ${psychicFrame.totalReadings} ${psychicFrame.since} ${psychic.serviceStartYear}`}
  </span>
);
